import { KeyRound } from 'lucide-react';
import { Link } from 'react-router-dom';

import { useConfig } from '@chainlit/react-client';

import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from '@/components/ui/tooltip';
import { Translator } from 'components/i18n';

export default function ApiKeys({ mobile }: { mobile?: boolean }) {
  const { config } = useConfig();
  const requiredKeys = !!config?.userEnv?.length;

  if (!requiredKeys) return null;

  if (mobile) {
    return (
      <Link to="/env" className="w-full">
        <Button
          id="api-keys-button"
          variant="ghost"
          className="w-full justify-start text-muted-foreground hover:text-foreground"
        >
          <KeyRound className="mr-2 !size-5" />
          <Translator path="navigation.user.menu.apiKeys" />
        </Button>
      </Link>
    );
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Link to="/env">
            <Button
              id="api-keys-button"
              size="icon"
              variant="ghost"
              className="text-muted-foreground hover:text-muted-foreground"
            >
              <KeyRound className="!size-5" />
            </Button>
          </Link>
        </TooltipTrigger>
        <TooltipContent>
          <p>
            <Translator path="navigation.user.menu.apiKeys" />
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
